const STORAGE_KEY = '__nexus_silent_login__';
const MAX_AGE_MS = 60_000;

export type SilentLoginState = { returnTo?: string };

type StoredAttempt = { state: SilentLoginState; startedAt: number };

const isFresh = (raw: string | null): boolean => {
  if (!raw) {
    return false;
  }
  try {
    const { startedAt } = JSON.parse(raw) as Partial<StoredAttempt>;
    return typeof startedAt === 'number' && Date.now() - startedAt <= MAX_AGE_MS;
  } catch {
    return false;
  }
};

export const beginSilentLogin = (state: SilentLoginState): boolean => {
  try {
    if (isFresh(sessionStorage.getItem(STORAGE_KEY))) {
      return false;
    }
    const attempt: StoredAttempt = { state, startedAt: Date.now() };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(attempt));
    return true;
  } catch {
    return false;
  }
};

export const clearSilentLogin = (): void => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // nothing stored if storage is unavailable
  }
};

export const consumeSilentLogin = (): SilentLoginState | undefined => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
    if (!raw) {
      return undefined;
    }
    const attempt = JSON.parse(raw) as Partial<StoredAttempt>;
    if (typeof attempt.startedAt !== 'number' || Date.now() - attempt.startedAt > MAX_AGE_MS) {
      return undefined;
    }
    return attempt.state ?? {};
  } catch {
    return undefined;
  }
};
